import cn from 'classnames';
import styles from './InfoList.module.css';

const profiled = [
    'Aircondition',
    'Internettilgang',
    'Balkong/terrasse',
    'Garasje/parkeringsplass',
    'Innendørs svømmebasseng',
    'Utendørs svømmebasseng',
    'Basseng',
    'Kjøkken',
];

export type InfoListProps = {
    list: string[] | null;
    title: string;
    split?: boolean;
};

export const InfoList = ({ list, title, split }: InfoListProps) => {
    const listHasElements = list && list.length > 0;

    const listWithoutDuplicates = [...new Set(list)];

    const listItems = (items: string[]) => (items.length ? items.map((item) => <li key={item}>{item}</li>) : null);

    const splitFacilities = (items: string[]) => (
        <>
            {listItems(items.filter((item) => profiled.indexOf(item) >= 0))}
            {listItems(items.filter((item) => profiled.indexOf(item) < 0))}
        </>
    );

    return (
        listHasElements && (
            <section className="mx-0">
                <h3 data-testid="poiNearBy-title">{title}</h3>
                <div className="preserve-linebreaks mt-16" data-testid="adFacilities">
                    <ul
                        className={cn('list grid grid-cols-2 md:grid-cols-3 gap-8', styles['facilities--expanded'])}
                        data-testid="adInfoList">
                        {split ? splitFacilities(listWithoutDuplicates) : listItems(listWithoutDuplicates)}
                    </ul>
                </div>
            </section>
        )
    );
};
